export default __webpack_public_path__ + "static/media/polygon_2.b7801ae1.svg";